import { getExceptionFromAxiosError } from '@/client/helpers';
import { IntercomJwtResponse, User } from '@/client/users';
import { AxiosError, AxiosInstance, AxiosResponse } from 'axios';
import { User as AuthUser } from 'oidc-client-ts';

export const currentUserService = (client: AxiosInstance) => {
  const ME_BASE_URL = '/me';

  const getMe = async (currentAccountId?: string): Promise<User> => {
    try {
      const headers: Record<string, string> = {};
      if (currentAccountId) {
        headers['x-current-account-id'] = currentAccountId;
      }

      const result = await client.get<User, AxiosResponse<User>>(ME_BASE_URL, {
        withCredentials: true,
        headers,
        params: { ignoreDemoMode: true },
      });

      return result.data;
    } catch (e) {
      throw getExceptionFromAxiosError(e as AxiosError);
    }
  };

  const updateLastLoginDate = async (user: AuthUser): Promise<User> => {
    try {
      const result = await client.patch<User, AxiosResponse<User>>(
        `${ME_BASE_URL}/authenticated`,
        {},
        {
          withCredentials: true,
          headers: {
            Authorization: `Bearer ${user?.access_token}`,
          },
        },
      );

      return result.data;
    } catch (e) {
      throw getExceptionFromAxiosError(e as AxiosError);
    }
  };

  const getIntercomJwt = async (): Promise<IntercomJwtResponse> => {
    try {
      const result = await client.get<
        IntercomJwtResponse,
        AxiosResponse<IntercomJwtResponse>
      >(`${ME_BASE_URL}/intercom-jwt`, {
        withCredentials: true,
      });

      return result.data;
    } catch (e) {
      throw getExceptionFromAxiosError(e as AxiosError);
    }
  };

  return { getMe, updateLastLoginDate, getIntercomJwt };
};
